import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowleftFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.378 17.777-4.575-5.014a1.2 1.2 0 0 1-.23-.357A1.1 1.1 0 0 1 8.5 12a1.1 1.1 0 0 1 .073-.406q.072-.185.23-.357l4.575-5.014a.7.7 0 0 1 .211-.163.54.54 0 0 1 .25-.06q.267 0 .464.198a.7.7 0 0 1 .197.521v10.562q0 .324-.199.521a.64.64 0 0 1-.463.198q-.067 0-.46-.223"
  }));
}
var IcArrowleftFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowleftFill));

export { IcArrowleftFill as I };
